const m = window.require("discourse/widgets/raw-html");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;